import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss', '../styles.css'],
    standalone: false
})

export class AppComponent {
  title = 'RecycleTracker';

  constructor() {}

  ngOnInit() {
  }

}